import styled from 'styled-components'

type Props = {
	size: number
}

export const BrandWrapper = styled.div<Props>`
	display: inline-block;
	position: relative;
	flex-shrink: 0;

	width: ${({ size }) => size}px;
	height: ${({ size }) => size}px;
`
